import React, { useContext, useEffect, useState } from 'react';
import { Typography, Button, Input, Spinner } from "@material-tailwind/react";
import CreatableSelect from 'react-select/creatable';
import { NewContext } from '../../Context/NewContext';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { update_bank_regex } from '../../Controller/actions';
import { toast } from 'react-toastify';

export const BankRegexModel = ({ getBankData }) => {
    const { isModalLoading, handleClose, handleChange, isLoading, setIsLoading, formData, open, addEditDeleteTag, setIsModalLoading, setFormData } = useContext(NewContext);
    const handleSubmit = async (e) => {
        e.preventDefault();
        let createupdateAsset;
        setIsLoading(true);
        if (addEditDeleteTag === "update") {
            createupdateAsset = await update_bank_regex({ ...formData }, formData?._id);
            getBankData();
        } else {
            getBankData();
            // createupdateAsset = await add_asset({ ...formData, title: selectedAssetOptions.value });
        }
        setIsLoading(false);
        if (createupdateAsset) {
            const { message, status } = createupdateAsset;
            if (status) {
                toast.success(message);
                setFormData([]);
                handleClose();
            } else {
                toast.error(message);
            }
        }
        handleClose();
    };

    // useEffect(() => {
    //     setFormData({ ...formData });
    // }, [setFormData]);

    return (
        <>
            <Dialog
                open={open}
                onClose={() => { handleClose(); }}
                aria-labelledby="responsive-dialog-title"
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                            height: "100%",
                            maxWidth: "400px",
                            maxHeight: "550px",
                            borderRadius: "12px"
                        },
                    },
                }} >
                <DialogTitle id="responsive-dialog-title" className='p-0 mb-[30px] text-[#1E1627]'>
                    {
                        addEditDeleteTag === 'view' ? 'Details View' : addEditDeleteTag === 'update' ? `Edit Bank Regex` : `Add Bank Regex`
                    }
                </DialogTitle>
                <DialogContent>
                    <div>
                        {
                            addEditDeleteTag !== 'view' ?
                                <form onSubmit={handleSubmit}>
                                    <div className="mt-5 grid grid-cols-1 lg:grid-cols-6 gap-5 add-edit-form">
                                        <div className="sm:col-span-6">
                                            <label htmlFor="countryCode" className="block  font-medium leading-5 mt-4">Country:</label>
                                            <div className="mt-2">
                                                <Input id='countryCode' required placeholder='Enter countryCode' name='countryCode' onChange={handleChange} value={formData?.countryCode} autoComplete='off' />
                                            </div>
                                        </div>
                                        <div className="sm:col-span-6">
                                            <label htmlFor="name" className="block  font-medium leading-5 mt-4">Bank Name:</label>
                                            <div className="mt-2">
                                                <Input id='name' required placeholder='Enter name' name='name' onChange={handleChange} value={formData?.name} autoComplete='off' />
                                            </div>
                                        </div>
                                        <div className="sm:col-span-6">
                                            <label htmlFor="regex" className="block  font-medium leading-5 mt-4">Regex:</label>
                                            <div className="mt-2">
                                                <Input id='regex' required placeholder='Enter regex' name='regex' onChange={handleChange} value={formData?.regex} autoComplete='off' />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='flex justify-end mt-24'>
                                        <Button onClick={() => { handleClose() }} className="mr-1 px-5 py-2.5 bg-white shadow-none text-[#1E3354] font-medium border border-[#75869F] hover:shadow-none capitalize text-base"
                                        >
                                            <span>Cancel</span>
                                        </Button>
                                        <Button className="flex items-center mr-1 px-5 py-2.5 bg-[#0047FF] shadow-none text-white font-medium border border-[#0047FF] hover:shadow-none capitalize text-base"
                                            type='submit'
                                        >
                                            {isModalLoading && <Spinner className="h-4 w-4" />}
                                            <span className={isModalLoading && 'ml-4'}>{addEditDeleteTag === `add` ? `Add` : `Update`}</span>
                                        </Button>
                                    </div>
                                </form>
                                :
                                <div>
                                </div>
                        }
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default BankRegexModel;
